export default "__VITE_ASSET__C7$JdmkK__"